import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23d2ff74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-area" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))
const _hoisted_3 = { class: "dialog-wrap" }
const _hoisted_4 = { class: "dialog-hd" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-hd-title" }, "报名已结束", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-bd" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dialog-bd-text" }, "比赛报名已结束，期待下次大赛您的参与")
], -1))
const _hoisted_7 = { class: "dialog-ft" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (_ctx.showClose)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: "https://static.wecity.qq.com/miying/close-icon-while-4a6b7678f014a3581fbbaa859f65dd40.png",
              alt: "",
              class: "dialog-hd-close",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
            }))
          : _createCommentVNode("", true)
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        (_ctx.showClose)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "dialog-ft-btn",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
            }, "确定"))
          : _createCommentVNode("", true)
      ])
    ])
  ], 512)), [
    [_vShow, _ctx.dialogShow]
  ])
}